<template>
    <div id="home-slider-two" v-if="items">
        <flickity  class="flickity" ref="flickity" :options="flickityOptions">
            <div class="carousel-cell"  v-for="item in items" :key="item" :style="{backgroundImage: 'url('+ $store.state.base_urls.webUploads + item.image+')'}" ></div>
        </flickity>
    </div>
    <div v-if="loadingMood">
        <img style="height: auto;width: 50%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
    </div>
</template>

<script>
    // @ is an alias to /src
    import Flickity from 'vue-flickity'
    import axios from 'axios'
    export default {
        name: "HomeSliderOne",
        components:{
            Flickity
        },
        data () {
            return {
                flickityOptions: {
                    initialIndex: 3,
                    prevNextButtons: false,
                    pageDots: false,
                    wrapAround: false,
                    freeScroll: true,
                    rightToLeft: true,
                    autoPlay: 1500,
                    arrowShape: {
                        x0: 30,
                        x1: 45, y1: 20,
                        x2: 55, y2: 20,
                        x3: 40
                    }
                    // any options from Flickity can be used
                },
                alertContent: null,
                loadingMood: false,
                infos:null,
                items:null
            }
        },
        methods:{
            async getPageInfos() {
                try {
                    this.loadingMood = true;
                    let response = await axios.get('api/getLatestSuccessfulCases',);
                    this.loadingMood = false;
                    this.items = response.data.results;
                } catch (error) {
                    console.log(error)
                }
            },
        },
        mounted() {
            this.getPageInfos();
        },
    }
</script>

<style scoped>

    #home-slider-two{
        padding-bottom: 20px;
    }

    .flickity{
        background-size: cover;
        background-repeat: no-repeat;
        margin-bottom: 50px;
    }
    .slider-cover{
        border-radius: 10px;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: black;
        opacity: 0.5;
    }
    .title{
        padding: 0 30px;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        right: 0;
        font-size: 18px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
    }
    .details{
        font-family: 'IRANSans';
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #ffffff;
    }
    .date-detail{
        position: absolute;
        width: auto;
        height: 25px;
        bottom: 10px;
        right: 10px;
    }
    .time-detail{
        position: absolute;
        width: auto;
        height: 25px;
        bottom: 10px;
        left: 10px;
    }

    #slider-title{
        text-align: right;
        font-size: 36px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #ffffff;
        margin-top: 0;
    }
    .carousel-cell{
        background-size:cover ;
        background-repeat: no-repeat;
        position: relative;
        border-radius: 10px;
        margin: 15px;
        width: 370px;
        height: 197px;
        background-color: red;
    }

    .carousel-cell.is-selected > .slider-cover {
        opacity: 0.8!important;
    }




</style>